import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";
import { scrollElementTo, scrollPageTo, getDOMElementByEntityId } from "../utils/DOMUtils";

//one action to combine the scroll logic
export function scrollToSirenAction(action, widgetId, path) {
    return (dispatch, getState) => {
        let targets = action.targets || [];
        let targetEntity = targets[0];
        if (targetEntity === "{top}") {
            scrollToTop();
            return Promise.resolve();
        }
        if (targetEntity === "{bottom}") {
            scrollToBottom();
            return Promise.resolve();
        }
        if (targetEntity === "{self}") {
            targetEntity = path;
        }
        if (targetEntity.includes("{widget}")) {
            //widget id is not the binding path
            let widget = getState().getIn(["data", widgetId, "class", 0]);
            targetEntity = targetEntity.replace("{widget}", widget);
        }

        let targetDOMElement = getDOMElementByEntityId(targetEntity);
        if (targetDOMElement) {
            scrollPageTo(targetDOMElement, action.properties);
        }

        return Promise.resolve();
    };
}

export function scrollPageToSirenAction(action, widgetId, path) {
    return (dispatch, getState) => {
        let dependencies = action.dependencies || action.targets || [];
        let targetEntity = dependencies[0];
        let targetDOMElement = getDOMElementByEntityId(targetEntity);

        return scrollPageTo(targetDOMElement, action.properties);
    };
}

//scrolls a scroll container to an inner element
//Example: Extranet location list for geolocations on mobile devices
export function scrollElementToSirenAction(action, widgetId, path) {
    return scrollTo(action.dependencies);
}

//scrolling each dependant entitiy into view in regards to the previous
//requires paths to scrollable containers
export function scrollTo(entities = []) {
    if (entities.length < 1) {
        WEBUILogs.error("Missing scrollTo action parameter.");
    }
    return (dispatch, getState) => {
        let domElements = entities.map((entity, index) => {
            return getDOMElementByEntityId(entity);
        });

        domElements.forEach((element, index) => {
            let continaerElement;
            //DOM element may not be found
            if (!element) return;
            //first element is skipped for it scrollPageTo can be used
            if (index === 0) return;

            continaerElement = getScrollContainerElement(domElements[index - 1]);

            //scrolling scrollElement into position
            scrollElementTo(continaerElement, element);
        });
    };
}

//each container can specify additional selector: scrollContainerSelector
//for the actual element that can be scrolled
//example: ScrollContainer, react-custom-scrolls uses extra elements for scrollable area
function getScrollContainerElement(container) {
    let scrollContainerElement = container;
    let additionalScrollSelector = container.attributes.getNamedItem("data-container-selector");
    if (additionalScrollSelector) {
        scrollContainerElement = container.querySelector(additionalScrollSelector.value);
    }

    return scrollContainerElement;
}

//Scrolling page to top
export function scrollToTop() {
    //Chrome/Edge case
    document.body.scrollTop = 0;
    //Rest of the world
    document.documentElement.scrollTop = 0;
}

//Scrolling page to bottom
export function scrollToBottom() {
    var scroll = function() {
        //Chrome/Edge case
        document.body.scrollTop = document.body.scrollHeight;
        //Rest of the world
        document.documentElement.scrollTop = document.body.scrollHeight;
    };
    setTimeout(scroll, 200);
}
